import { useId, useState } from 'react';
import { SCORE_LETTERS, type ScoreDimension, type ScoreLetter, type DimLang } from '../../shared/scoreDimensions';
import { useT } from '../i18n';
interface Props { dimension: ScoreDimension; value: ScoreLetter | null; onChange: (v: ScoreLetter | null) => void; explain?: boolean }
/** A compact comparison row: the entire labelled choice is a native radio target. */
export function ScoreScale({ dimension, value, onChange, explain=true }: Props) {
  const { lang }=useT(), id=useId(), dl=lang as DimLang;
  const [preview,setPreview]=useState<ScoreLetter | null>(null);
  const shown=preview ?? value;
  return <fieldset className="assessment-row">
    <legend>{dimension.label[dl]}</legend>
    <div className="assessment-options">
      {SCORE_LETTERS.map(letter => <label key={letter} className={`assessment-option ${value===letter?'is-selected':''}`}
        onMouseEnter={()=>setPreview(letter)} onMouseLeave={()=>setPreview(null)}>
        <input type="radio" name={id} value={letter} checked={value===letter} onChange={()=>onChange(letter)}
          onFocus={()=>setPreview(letter)} onBlur={()=>setPreview(null)} aria-describedby={`${id}-criteria`} />
        <strong>{letter}</strong><span>{dimension.levels[letter].short[dl]}</span>
      </label>)}
    </div>
    <div className="assessment-caption">
      <span id={`${id}-criteria`}>{explain ? (shown ? dimension.levels[shown].desc[dl] : dimension.help[dl]) : value ? dimension.levels[value].short[dl] : (lang==='fr'?'Non évalué':'Not assessed')}</span>
      {value && <button type="button" className="btn btn-sm btn-ghost" onClick={()=>onChange(null)}>{lang==='fr'?'Effacer':'Clear'}</button>}
    </div>
  </fieldset>;
}
